import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
// import { Provider } from "react-redux";
// import configureStore from "./redux/configureStore";
// import history from "./utils/history";

import App from './components/App';
import GlobalStyle from './theme/globalStyles';
import theme from './theme/theme';
import * as serviceWorker from './serviceWorker';

if (!navigator.cookieEnabled) {
  alert('Enable cookies for comfortable work with this site.');
}

// const initialState = {};
// const store = configureStore(initialState, history);

class Index extends Component {
  state = {
    bodyHeight: 'auto',
    render: false,
  };
  componentDidMount() {
    this.setState({
      bodyHeight: window.innerHeight,
      render: true,
    });
  }

  render() {
    const { render, bodyHeight } = this.state;
    return (
      <ThemeProvider theme={theme}>
        <div>
          {render && <App />}
          <GlobalStyle bodyHeight={bodyHeight} />
        </div>
      </ThemeProvider>
    );
  }
}

ReactDOM.render(<Index />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
